"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CLASS_FORM_TITLE = exports.DEFAULT_CLASS = exports.modalTypes = void 0;
exports.modalTypes = {
    transferOffers: {
        type: 'transferOffers',
        title: 'class_manager.modal.transfer_offers_title',
        body: 'class_manager.modal.transfer_offers_body'
    },
    setDefaultClass: {
        type: 'setDefaultClass',
        title: 'class_manager.modal.set_default_class_title',
        body: 'class_manager.modal.set_default_class_body'
    },
    setCommonClass: {
        type: 'setCommonClass',
        title: 'class_manager.modal.set_common_class_title',
        body: 'class_manager.modal.set_common_class_body'
    },
    deleteClass: {
        type: 'deleteClass',
        title: 'class_manager.modal.delete_class_title',
        body: 'class_manager.modal.delete_class_body'
    },
    transferStudents: {
        type: 'transferStudents',
        title: 'class_manager.modal.transfer_students_title',
        body: 'class_manager.modal.transfer_students_body'
    }
};
exports.DEFAULT_CLASS = {
    ENTITY: 'membership.default.class.name',
    NAME: 'general.default_class',
    INFO: 'general.default_class_label'
};
exports.CLASS_FORM_TITLE = {
    NEW: 'class_manager.class_editor.create_class',
    EDIT: 'class_manager.class_editor.edit_class'
};
